import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    personMovies: [],
    personMoviesLoading: false,
    personMoviesError: null,
};

const personMoviesSlice = createSlice({
    name: "personMovies",
    initialState,
    reducers: {
        fetchPersonMoviesStart(state, action) {
            state.personMoviesLoading = true;
            state.personMoviesError = null;
        },
        fetchPersonMoviesSuccess(state, action) {
            state.personMoviesLoading = false;
            state.personMovies = action.payload;
        },
        fetchPersonMoviesFailure(state, action) {
            state.personMoviesLoading = false;
            state.personMoviesError = action.payload;
        },
        clearPersonMovies: (state) => {
            state.personMovies = [];
            state.personMoviesLoading = false;
            state.personMoviesError = null;
        },
    }
}
);

export const {
    fetchPersonMoviesStart,
    fetchPersonMoviesSuccess,
    fetchPersonMoviesFailure,
    clearPersonMovies,
} =
    personMoviesSlice.actions;

export default personMoviesSlice.reducer;